import { render, staticRenderFns } from "./RealForm.vue?vue&type=template&id=6a1e67b0"
import script from "./RealForm.vue?vue&type=script&lang=js"
export * from "./RealForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports